export type AnalyticsGateInput = {
	appEnv: string;
	isDev: boolean;
	key: string;
	hostname: string;
};

const STAGING_HOSTS = ['vadio.app'];
const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

const matchesHost = ({ hostname, hosts }: { hostname: string; hosts: readonly string[] }): boolean =>
	hosts.some((host) => hostname === host || hostname.endsWith(`.${host}`));

export const isAnalyticsEnabled = ({ appEnv, isDev, key, hostname }: AnalyticsGateInput): boolean => {
	if (isDev || appEnv === 'e2e') return false;
	if (!key) return false;

	const isStagingHost = matchesHost({ hostname, hosts: STAGING_HOSTS });
	if (appEnv === 'staging') return isStagingHost;
	if (appEnv !== 'production') return false;

	return !isStagingHost && !matchesHost({ hostname, hosts: LOCAL_HOSTS });
};
